module.exports = __webpack_public_path__ + "static/img/h-train.ff620b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/home/h-train.jpg
// module id = +1W4
// module chunks = 1